import md5 from 'md5'

import { isWindowDefined } from '@chegg-wt/core/utils/isWindowDefined'
import { getCookie, setCookie, Cookies } from './cookies'

// Javascript version of PHP uniqid function which is used to
// create the V cookie on chegg.com
export const uniqid = () => {
  const dateMicroseconds = Date.now() / 1000
  let dateString = dateMicroseconds.toString(16).split('.').join('')

  while (dateString.length < 14) {
    dateString += '0'
  }

  const randomNumber = Math.random() * 1000
  const randomString = randomNumber.toString()

  return `${md5(randomString)}${dateString}.${Math.floor(
    10000000 + Math.random() * 80000000
  )}`
}

export const getVCookie = () => getCookie(Cookies.ExperimentIdentifier)

export const getOrSetVCookie = (domain: string) => {
  if (!isWindowDefined) return null
  const vCookie = getVCookie()

  if (vCookie) return vCookie

  const vHash = uniqid()

  const date = new Date()

  // V Cookie on chegg.com lasts 10 years
  const expires = new Date(date.getFullYear() + 10, date.getMonth(), date.getDay())

  setCookie(Cookies.ExperimentIdentifier, vHash, { domain, expires })

  return vHash
}

export const getOrSetVCookieServer = (domain: string, ctx: any) => {
  const { req, res } = ctx

  const vCookie = req && req.cookies && req.cookies[Cookies.ExperimentIdentifier]

  if (vCookie) return vCookie

  const vHash = uniqid()

  const date = new Date()

  // V Cookie on chegg.com lasts 10 years
  const expires = new Date(date.getFullYear() + 10, date.getMonth(), date.getDay())
  if (res?.cookie) {
    res.cookie(Cookies.ExperimentIdentifier, vHash, {
      domain,
      expires,
      secure: true,
    })
  }

  return vHash
}
